import Vue from 'vue'
import Vuex from 'vuex'
// Modules
import Profile from './Profile'
import Users from './Users'
import OrganizerUsers from './Organizers'
import Lots from './Lots'
import Lot from './Lot/operator'
import LotOrganizer from './Lot/organizer'
import Regions from './Regions'
import Operator from './Operator'
import Tariff from './Tariff'
import OperatorActionsLog from './Logs/OperatorActionsLog'
import UserActionsLog from './Logs/UserActionsLog'
import AccountOperationsLog from './Logs/AccountOperationsLog'
import AccountOperationsExcerptLog from './Logs/AccountOperationsExcerptLog'
import ETPAccounts from './Accounts/ETPAccounts'
import AccountUsersList from './Accounts/AccountUsersList'
import Messages from './Messages'
import Withdraws from './Withdraws'
import UserWithdrawRequestsList from './Accounts/UserWithdrawRequestsList'
import UserWithdrawRequest from './Accounts/UserWithdrawRequest'
import OrganizerTemplateDocuments from './OrganizerTemplates/documents'
import Banners from './Banners'
import Faq from './Faq'
import MailConfig from './MailConfig'
import TimeZones from './TimeZones'
import Principals from './Principals'
import Settings from './Settings'


Vue.use(Vuex);

const store = new Vuex.Store({
    strict: process.env.NODE_ENV !== "production",
    modules: {
        Profile,
        UserActionsLog,
        Users,
        OrganizerUsers,
        Operator,
        OperatorActionsLog,
        AccountOperationsLog,
        AccountOperationsExcerptLog,
        ...{Lots, MyLots: Lots, UserLots: Lots, OrganizerMyLots: Lots},
        Lot,
        LotOrganizer,
        Regions,
        Tariff,
        ETPAccounts,
        AccountUsersList,
        Messages,
        Withdraws,
        UserWithdrawRequestsList,
        UserWithdrawRequest,
        OrganizerTemplateDocuments,
        Banners,
        Faq,
        MailConfig,
        TimeZones,
        Principals,
        Settings
    },
});

export default store;
